<template>
  <div>
    <Divider orientation="left"><b>{{ $route.query.domain }}</b></Divider>
    <Form :model="dateFilter" style="margin: 20px 0 0 0;" ref="graphScreenFilter" label-position="left" inline>
      <FormItem>
        <radio-group v-model="dateFilter.date" type="button" @on-change="lastTimeChange">
          <radio label="today">今天</radio>
          <radio label="yesterday">昨天</radio>
          <radio label="seven">最近7天</radio>
          <radio label="thirty">最近30天</radio>
        </radio-group>
      </FormItem>
      <FormItem>
        <DatePicker
          :value="customDate"
          type="daterange"
          style="min-width: 250px;"
          @on-change="customTimeChange"
          @on-clear="customTimeClear"
          placeholder="自定义时间"
          class="mob-w-100"></DatePicker>
      </FormItem>
    </Form>
    <Row :gutter="16">
      <Spin fix v-if="loading"></Spin>
      <Col :lg="12">
        <Card style="margin-bottom: 16px">
          <p slot="title">
            <b>Top10来源网站</b>
          </p>
          <div v-if="data.sourceSite">
            <table style="width: 100%; table-layout: fixed;">
              <thead>
                <tr style="color: #787a7d">
                  <td>来源网站</td>
                  <td width="20%" style="text-align: right">浏览量(PV)</td>
                  <td width="20%" style="text-align: right">占比</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in data.sourceSite.items" :key="item[0]" style="height: 30px">
                  <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ item[0] }}</td>
                  <td style="text-align: right">{{ item[1] }}</td>
                  <td style="text-align: right">{{ item[2] }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </Col>
      <Col :lg="12">
        <Card style="margin-bottom: 16px">
          <p slot="title">
            <b>Top10入口页面 </b>
          </p>
          <div v-if="data.landingPage">
            <table style="width: 100%; table-layout: fixed;">
              <thead>
              <tr style="color: #787a7d">
                <td>入口页面</td>
                <td width="20%" style="text-align: right">浏览量(PV)</td>
                <td width="20%" style="text-align: right">占比</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data.landingPage.items" :key="item[0]" style="height: 30px">
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                  <a target="_blank" :href="item[0]">{{ item[0] }}</a>
                </td>
                <td style="text-align: right; ">{{ item[1] }}</td>
                <td style="text-align: right;">{{ item[2] }}%</td>
              </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </Col>
      <Col :lg="12">
        <Card style="margin-bottom: 16px">
          <p slot="title">
            <b>Top10受访页面</b>
          </p>
          <div v-if="data.visitPage">
            <table style="width: 100%; table-layout: fixed;">
              <thead>
              <tr style="color: #787a7d">
                <td>受访页面</td>
                <td width="20%" style="text-align: right">浏览量(PV)</td>
                <td width="20%" style="text-align: right">占比</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data.visitPage.items" :key="item[0]" style="height: 30px">
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                  <a target="_blank" :href="item[0]">{{ item[0] }}</a>
                </td>
                <td style="text-align: right">{{ item[1] }}</td>
                <td style="text-align: right">{{ item[2] }}%</td>
              </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </Col>
      <Col :lg="12">
        <Card style="margin-bottom: 16px">
          <p slot="title">
            <b>新老访客</b>
          </p>
          <div v-if="data.visitType ">
            <table class="visit-type">
              <thead>
                <tr style="color: #787a7d; height: 30px">
                  <td></td>
                  <td width="30%" style="text-align: center">新访客</td>
                  <td width="30%" style="text-align: center">老访客</td>
                </tr>
              </thead>
              <tbody>
              <tr style="height: 50px">
                <td style="text-align: center">占比</td>
                <td style="text-align: center"><b>{{ data.visitType.newVisitor.ratio }}</b></td>
                <td style="text-align: center"><b>{{ data.visitType.oldVisitor.ratio }}</b></td>
              </tr>
              <tr style="height: 50px">
                <td style="text-align: center">浏览量</td>
                <td style="text-align: center"><b>{{ data.visitType.newVisitor.pv_count }}</b></td>
                <td style="text-align: center"><b>{{ data.visitType.oldVisitor.pv_count }}</b></td>
              </tr>
              <tr style="height: 50px">
                <td style="text-align: center">访客数</td>
                <td style="text-align: center"><b>{{ data.visitType.newVisitor.visitor_count }}</b></td>
                <td style="text-align: center"><b>{{ data.visitType.oldVisitor.visitor_count }}</b></td>
              </tr>
              <tr style="height: 50px">
                <td style="text-align: center">跳出率</td>
                <td style="text-align: center"><b>{{ data.visitType.newVisitor.bounce_ratio }}%</b></td>
                <td style="text-align: center"><b>{{ data.visitType.oldVisitor.bounce_ratio }}%</b></td>
              </tr>
              <tr style="height: 50px">
                <td style="text-align: center">平均访问时长</td>
                <td style="text-align: center"><b>{{ formatSeconds(data.visitType.newVisitor.avg_visit_time) }}</b></td>
                <td style="text-align: center"><b>{{ formatSeconds(data.visitType.oldVisitor.avg_visit_time) }}</b></td>
              </tr>
              <tr style="height: 50px">
                <td style="text-align: center">平均访问页数</td>
                <td style="text-align: center"><b>{{ data.visitType.newVisitor.avg_visit_pages }}</b></td>
                <td style="text-align: center"><b>{{ data.visitType.oldVisitor.avg_visit_pages }}</b></td>
              </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>

import { getAnalyseSiteCountCommon } from '@/api/opscenter'

export default {
  name: 'detail',
  data () {
    return {
      loading: false,
      dateFilter: {
        date: 'today',
        start: '',
        end: ''
      },
      customDate: ['', ''],
      data: {}
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.params.site_id) {
        this.getData()
      }
    }
  },
  created: function () {
    this.getData()
  },
  methods: {
    getData () {
      let params = {
        site_id: this.$route.params.site_id,
        start_date: this.dateFilter.start,
        end_date: this.dateFilter.end
      }
      this.loading = true
      getAnalyseSiteCountCommon(params).then(res => {
        this.loading = false
        this.data = res.data
      }).catch(res => {
        this.loading = false
        console.error(res.response)
      })
    },
    // 刷新
    refresh () {
      this.getData()
    },
    // 计算过去的日期
    timeC (day) {
      let date = new Date()
      let sD = new Date(date.getTime() - day * 24 * 60 * 60 * 1000)
      let sYear = sD.getFullYear()
      let sMonth = (sD.getMonth() + 1 < 10 ? '0' + (sD.getMonth() + 1) : sD.getMonth() + 1)
      let sDay = sD.getDate()
      return sYear + sMonth + sDay
    },
    // 选中日期触发
    lastTimeChange (label) {
      this.customDate = ['', '']
      this.dateFilter.start = ''
      this.dateFilter.end = ''

      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let nowDate = year + month + day
      switch (label) {
        case 'today':
          this.dateFilter.start = nowDate
          this.dateFilter.end = nowDate
          break
        case 'yesterday':
          let yesterdayStr = this.timeC(1)
          this.dateFilter.start = yesterdayStr
          this.dateFilter.end = yesterdayStr
          break
        case 'seven':
          this.dateFilter.start = this.timeC(7)
          this.dateFilter.end = nowDate
          break
        case 'thirty':
          this.dateFilter.start = this.timeC(30)
          this.dateFilter.end = nowDate
          break
      }
      this.$nextTick(() => {
        this.refresh()
      })
    },
    // 自定义时间触发
    customTimeChange (timeRange) {
      if (timeRange[0] && timeRange[1]) {
        this.dateFilter.date = ''
        this.dateFilter.start = timeRange[0].replace(/-/g, '')
        this.dateFilter.end = timeRange[1].replace(/-/g, '')
        this.$nextTick(() => {
          this.refresh()
        })
      } else {
        this.customTimeClear()
      }
    },
    // 自定义时间清除触发
    customTimeClear () {
      this.dateFilter.date = 'today'
      this.lastTimeChange('today')
    },
    formatSeconds (value) {
      var theTime = parseInt(value) // 秒
      var middle = 0 // 分
      var hour = 0 // 小时
      if (theTime > 60) {
        middle = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (middle > 60) {
          hour = parseInt(middle / 60)
          middle = parseInt(middle % 60)
        }
      }
      var result = '' + parseInt(theTime)
      if (middle > 0) {
        result = '' + parseInt(middle) + ':' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + ':' + result
      }
      return result
    }
  }
}
</script>

<style scoped>
  .visit-type , .visit-type tr th, .visit-type tr td {
    border:1px solid #ededef;
  }
  .visit-type {
    width: 100%;
    table-layout: fixed;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    padding:2px
  }
</style>
